import { AnalysisLayerAPI } from "@ai360/core";
export interface EquipmentFilter {
    equipmentGuid: string;
    equipmentName: string;
    errorCodeList: Array<number>;
}

export const importGroomingRequest = Object.freeze({
    groomingSessionGuid: null,
    importFileGuidList: [],
    isNameMatch: false,
    fieldGuidsToIgnoreList: [],
    selectedEventIdList: [],
    selectedFieldGuidList: [],
    selectedCropGuidList: [],
    selectedCroppingSeasonGuidList: [],
    selectedCustomerFieldList: [],
    selectAll: true,
    statFilter: true,
    yieldFilter: true,
    featuresCount: 0,
    filteredFieldImportFileList: [],
});

export const importEventPreviewRequest = Object.freeze({
    statFilter: true,
    yieldFilter: true,
    manualFilteredList: [],
    fieldList: [],
    filteredFieldImportFileList: [],
});

export const importFilterListData = Object.freeze({
    crops: [],
    croppingSeasons: [],
    fieldBoundaryList: [],
    fieldList: [],
    equipmentProfiles: [],
    products: [],
});

export const importFieldStrip = Object.freeze({
    customerGuid: "",
    customerName: "",
    farmName: "",
    features: 0,
    fieldGuid: "",
    fieldName: "",
    hasImported: false,
    importFileGuidList: [],
    noMatch: true,
});

export interface FieldEventDate {
    fieldGuid: string;
    eventDate: string | null;
    pointCount: number;
}

export interface ImportFile {
    importFileName: string;
    importFileGuid: string;
    pointCount: number;
    eventId: string | null;
    eventDates: FieldEventDate[];
}

export interface FieldStripRecord {
    fieldGuid: string;
    fieldName: string;
    customerName: string;
    customerGuid: string;
    farmName: string;
    pointCount: number;
    noMatch: boolean;
    importFileGuidList: ImportFile[];
    lockBoundary: boolean;
    acres: number;
    enrolledYn: boolean;
    eventDates: FieldEventDate[];
}

export enum AnalysisLayerImportStatus {
    Ready = "Ready",
    Processing = "Processing",
    ProcessingError = "ProcessingError",
    Completed = "Completed",
    Error = "Error",
}

export interface ProposedAnalysisLayerWithStatus extends AnalysisLayerAPI.ProposedAnalysisLayer {
    status: AnalysisLayerImportStatus;
}
